export const SUPPORT_CHAT_GET_CONVERSATIONS = "SUPPORT_CHAT_GET_CONVERSATIONS";
export const SUPPORT_CHAT_GET_CONVERSATION_MESSAGES = "SUPPORT_CHAT_GET_CONVERSATION_MESSAGES";
export const SUPPORT_CHAT_SEND_MESSAGE = "SUPPORT_CHAT_SEND_MESSAGE";
export const SUPPORT_CHAT_DELETE_CONVERSATION = "SUPPORT_CHAT_DELETE_CONVERSATION";
export const SUPPORT_CHAT_CHANGE_CONVERSATION_STATUS = "SUPPORT_CHAT_CHANGE_CONVERSATION_STATUS";
export const SUPPORT_CHAT_GET_USER_SUBCRIPTION = "SUPPORT_CHAT_GET_USER_SUBCRIPTION";
export const SUPPORT_CHAT_CHANGE_SUBSCRIPTION_STATUS = "SUPPORT_CHAT_CHANGE_SUBSCRIPTION_STATUS";
export const SUPPORT_CHAT_DELETE_SUBSCRIPTION = "SUPPORT_CHAT_DELETE_SUBSCRIPTION";
export const SUPPORT_CHAT_ADD_SUBCRIPTION = "SUPPORT_CHAT_ADD_SUBCRIPTION";
export const SUPPORT_CHAT_CHANGE_TICKET_STATUS = "SUPPORT_CHAT_CHANGE_TICKET_STATUS";
export const SUPPORT_CHAT_DELETE_TICKET = "SUPPORT_CHAT_DELETE_TICKET";